import React from 'react';
import * as S from './style';
import { TemplateWithProfile, TemplateWithTitle } from 'pages';
import { TabNavigation } from 'components';
import { FAMILYMOVE_INFO, SMALLMOVE_INFO, MOVECLEANING_INFO, USER_LIST, SERVICE_FEATURE } from 'router/PageUrl';
interface Props {
    children: React.ReactNode;
    title?: string;
    serviceIdx: number;
    serviceType: string;
    isBackBtn?: boolean;
}

function TemplateForService({ children, title, serviceIdx, serviceType, isBackBtn }: Props): React.ReactElement {
    const pathname = window.location.pathname;

    const setTabByServiceType = (serviceType: string) => {
        switch (serviceType) {
            case 'familymove':
                return [
                    {
                        path: FAMILYMOVE_INFO.url,
                        name: '서비스 관리',
                        active: pathname.includes(FAMILYMOVE_INFO.url),
                    },
                    {
                        path: USER_LIST.url + `/${serviceType}/${serviceIdx}`,
                        name: '직원관리',
                        active: pathname.includes(USER_LIST.url),
                    },
                    {
                        path: SERVICE_FEATURE.url + `/${serviceType}/${serviceIdx}/all`,
                        name: '제공 서비스',
                        active: pathname.includes(SERVICE_FEATURE.url),
                    }
                ];
            case 'smallmove':
                return [
                    {
                        path: SMALLMOVE_INFO.url,
                        name: '프로필',
                        active: pathname.includes(SMALLMOVE_INFO.url),
                    },
                    {
                        path: SERVICE_FEATURE.url + `/${serviceType}/${serviceIdx}/all`,
                        name: '제공 서비스',
                        active: pathname.includes(SERVICE_FEATURE.url),
                    }
                ];
            case 'movecleaning':
                return [
                    {
                        path: MOVECLEANING_INFO.url,
                        name: '프로필',
                        active: pathname.includes(MOVECLEANING_INFO.url),
                    },
                    {
                        path: USER_LIST.url + `/${serviceType}/${serviceIdx}`,
                        name: '직원관리',
                        active: pathname.includes(USER_LIST.url),
                    },
                    {
                        path: SERVICE_FEATURE.url + `/${serviceType}/${serviceIdx}/all`,
                        name: '제공 서비스',
                        active: pathname.includes(SERVICE_FEATURE.url),
                    }
                ];
            default:
                return [];
        }
    }

    const setTemplateByServiceType = (serviceType: string) => {
        switch (serviceType) {
            case 'familymove':
                return (
                    <TemplateWithProfile title={title} isBackBtn={isBackBtn} serviceType={serviceType} serviceIdx={serviceIdx}>
                        <S.NavigationWrapper>
                            <TabNavigation tabs={setTabByServiceType(serviceType)} />
                        </S.NavigationWrapper>
                        {children}
                    </TemplateWithProfile>
                );
            case 'smallmove':
            case 'movecleaning':
                return (
                    <TemplateWithTitle title={title} isBackBtn={isBackBtn}>
                        <S.NavigationWrapper>
                            <TabNavigation tabs={setTabByServiceType(serviceType)} />
                        </S.NavigationWrapper>
                        {children}
                    </TemplateWithTitle>
                );
            default:
                return <></>;
        }

    }

    return setTemplateByServiceType(serviceType);
}

export default TemplateForService;
